module.exports = __webpack_public_path__ + "media/packs/site/assets/images/logo_with_title-fb1139101399d2bbf9ac5308578985af.png";